import {
  IAuthCompleteRegistrationRequest,
  IAuthRegistrationPayload,
  IAuthRegistrationResponse,
  ILoginByOtpRequest,
  ILoginRequest,
  ILoginResponse,
  IResetPasswordResetRequest,
  IResetPasswordResetResponse,
  ISendPasswordResetLinkRequest,
  ISendPasswordResetLinkResponse,
} from '@src/api/types/auth.types';
import { axiosInstance } from '@src/configs/axios.configs';
import { IResponse } from '@src/interfaces/axios.interfaces';

export const authService = {
  registration: (
    data: IAuthRegistrationPayload,
  ): IResponse<IAuthRegistrationResponse> =>
    axiosInstance.post('/api/auth/registration', data, {
      withCredentials: false,
      hideDefaultErrorMessage: true,
    }),
  completeRegistration: (
    data: IAuthCompleteRegistrationRequest,
  ): IResponse<IAuthRegistrationResponse> =>
    axiosInstance.post('/api/auth/complete-registration', data),
  login: (data: ILoginRequest): IResponse<ILoginResponse> =>
    axiosInstance.post('api/auth/login', data),
  loginByOtp: (
    data: ILoginByOtpRequest,
    hideDefaultErrorMessage?: boolean,
  ): IResponse<ILoginResponse> =>
    axiosInstance.post('api/auth/login-by-token', data, {
      hideDefaultErrorMessage,
    }),
  sendPasswordResetLink: (
    data: ISendPasswordResetLinkRequest,
  ): IResponse<ISendPasswordResetLinkResponse> =>
    axiosInstance.post('api/auth/reset-password/send-link', data, {
      hideDefaultErrorMessage: true,
    }),
  resetPasswordReset: (
    data: IResetPasswordResetRequest,
  ): IResponse<IResetPasswordResetResponse> =>
    axiosInstance.post('api/auth/reset-password/reset', data),
};
